/* ==================================================================
   North Shore Peptides — Free gifts with purchase (auto add/remove)
   Two independent promos, each optional:
     - every: cart holds the gift IFF there is >= 1 real item.
     - min:   cart holds the gift IFF the real subtotal >= threshold.
   Config comes from window.FREE_GIFTS = { every?: {...}, min?: {...} }.
   Each promo config: { id, handle, enabled, toast, threshold? }.
   ================================================================== */
(function () {
  'use strict';

  var cfg = window.FREE_GIFTS;
  if (!cfg || (!cfg.every && !cfg.min)) return;

  var PROMOS = ['every', 'min'].filter(function (key) { return cfg[key] && cfg[key].id; });
  if (!PROMOS.length) return;

  var busy = false;      // re-entrancy guard
  var pending = false;   // a mutation landed while busy → re-run
  var userAction = false;// last cart mutation was user-triggered

  var JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  /* -------- cart helpers -------- */
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function giftIds() {
    return PROMOS.map(function (key) { return cfg[key].id; });
  }
  function realQty(cart) {
    var ids = giftIds();
    var n = 0;
    (cart.items || []).forEach(function (it) { if (ids.indexOf(it.variant_id) === -1) n += it.quantity; });
    return n;
  }
  function realSubtotal(cart) {
    var ids = giftIds();
    var n = 0;
    (cart.items || []).forEach(function (it) { if (ids.indexOf(it.variant_id) === -1) n += it.final_line_price; });
    return n;
  }
  function giftLine(cart, id) {
    return (cart.items || []).filter(function (it) { return it.variant_id === id; })[0];
  }
  function addGift(id) {
    return fetch('/cart/add.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: id, quantity: 1 }) });
  }
  function removeGift(key) {
    return fetch('/cart/change.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: key, quantity: 0 }) });
  }

  /* -------- UI sync -------- */
  function syncCounts(cart) {
    var count = cart.item_count || 0;
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]').forEach(function (el) {
      el.textContent = count < 100 ? count : '';
    });
  }
  function refreshSection(sectionId) {
    return fetch('/?section_id=' + sectionId).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (sectionId === 'cart-icon-bubble') {
        var target = document.getElementById('cart-icon-bubble');
        var src = doc.querySelector('.shopify-section') || doc.body;
        if (target) target.innerHTML = src.innerHTML;
        return;
      }
      // cart drawer
      ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
        var t = document.querySelector(sel), s = doc.querySelector(sel);
        if (t && s) t.replaceWith(s);
      });
      var srcDrawer = doc.querySelector('cart-drawer'), curDrawer = document.querySelector('cart-drawer');
      if (srcDrawer && curDrawer) curDrawer.classList.toggle('is-empty', srcDrawer.classList.contains('is-empty'));
    }).catch(function () {});
  }
  function refreshCartUI() {
    var jobs = [refreshSection('cart-icon-bubble')];
    if (document.querySelector('cart-drawer')) jobs.push(refreshSection('cart-drawer'));
    return Promise.all(jobs);
  }

  /* -------- Toast (used for reduced-motion / no-modal fallback) -------- */
  function ensureToastHost() {
    var host = document.getElementById('np-toast-host');
    if (!host) { host = document.createElement('div'); host.id = 'np-toast-host'; document.body.appendChild(host); }
    return host;
  }
  function showToast(message, title) {
    var host = ensureToastHost();
    var t = document.createElement('div');
    t.className = 'np-toast';
    t.setAttribute('role', 'status');
    t.innerHTML =
      '<span class="np-toast__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m8.5 12 2.3 2.3 4.7-4.6"/></svg></span>' +
      '<span class="np-toast__body"><strong>' + (title || 'Added to cart') + '</strong><span>' + message + '</span></span>';
    host.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    window.setTimeout(function () {
      t.classList.remove('is-in');
      window.setTimeout(function () { t.remove(); }, 350);
    }, 4200);
  }
  window.npToast = showToast; // reusable

  /* -------- Unlock modal -------- */
  function showGiftModal(unlocked) {
    var modal = document.getElementById('NpGiftModal');
    if (!modal || typeof modal.show !== 'function') {
      // fallback: toast per unlocked promo
      unlocked.forEach(function (key) { showToast(cfg[key].toast, 'Free gift added'); });
      return;
    }
    modal.show(unlocked);
  }

  /* -------- Enforce -------- */
  function enforce() {
    if (busy) { pending = true; return; }
    busy = true;
    var wasUser = userAction; userAction = false;

    return getCart().then(function (cart) {
      var reals = realQty(cart);
      var subtotal = realSubtotal(cart);

      var toAdd = [];   // promo keys
      var toRemove = []; // {key, line}

      PROMOS.forEach(function (key) {
        var promo = cfg[key];
        var line = giftLine(cart, promo.id);
        var wants = key === 'min'
          ? !!(promo.enabled && subtotal >= promo.threshold)
          : !!(promo.enabled && reals >= 1);

        if (wants && !line) toAdd.push(key);
        if (!wants && line) toRemove.push({ key: key, line: line });
      });

      if (!toAdd.length && !toRemove.length) {
        syncCounts(cart);
        return;
      }

      var chain = Promise.resolve();
      toRemove.forEach(function (r) { chain = chain.then(function () { return removeGift(r.line.key); }); });
      toAdd.forEach(function (key) { chain = chain.then(function () { return addGift(cfg[key].id); }); });

      return chain.then(getCart).then(function (c2) {
        syncCounts(c2);
        var reals2 = realQty(c2);

        if (toRemove.length && reals2 === 0 && wasUser) {
          window.location.reload();
          return;
        }

        return refreshCartUI().then(function () {
          if (wasUser && toAdd.length) showGiftModal(toAdd);
        });
      });
    }).catch(function () {}).then(function () {
      busy = false;
      if (pending) { pending = false; enforce(); }
    });
  }

  /* -------- Intercept every cart mutation -------- */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
  var origFetch = window.fetch;
  window.fetch = function () {
    var input = arguments[0];
    var url = (typeof input === 'string' ? input : (input && input.url)) || '';
    var isCart = CART_RE.test(url);
    var p = origFetch.apply(this, arguments);
    if (isCart) {
      p.then(function () {
        if (busy) { pending = true; return; } // our own gift mutation or concurrent
        userAction = true;
        enforce();
      }).catch(function () {});
    }
    return p;
  };

  /* -------- Page load: silent self-heal (no toast, no modal, no reload) -------- */
  function onReady() { enforce(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
  else onReady();

  /* -------- Hide the gift(s) from predictive search (exact handle match) -------- */
  function filterPredictive() {
    var handles = PROMOS.map(function (key) { return (cfg[key].handle || '').toLowerCase(); }).filter(Boolean);
    if (!handles.length) return;
    document.querySelectorAll('#predictive-search-results a[href*="/products/"]').forEach(function (a) {
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m && handles.indexOf(m[1].toLowerCase()) !== -1) {
        var li = a.closest('li');
        if (li) li.remove(); else a.remove();
      }
    });
  }
  var psContainer = document.querySelector('predictive-search') || document.getElementById('predictive-search-results');
  if (psContainer) {
    var mo = new MutationObserver(function () { filterPredictive(); });
    mo.observe(psContainer, { subtree: true, childList: true });
  }
})();

/* ==================================================================
   Free-gift unlock modal — celebratory popup shown when a promo
   newly qualifies. Mirrors the theme's modal conventions
   (see assets/cart-disclosure-modal.js) but is opened programmatically
   rather than from a click opener.
   ================================================================== */
(function () {
  'use strict';
  if (customElements.get('np-gift-modal')) return;

  var LABELS = {
    every: 'Your free gift has been added to your cart.',
    min: 'You unlocked a free gift for qualifying for the order minimum.'
  };

  class NpGiftModal extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector('[role="dialog"]');
      this.subtitleEl = this.querySelector('[data-gift-modal-subtitle]');
      this.onClose = this.onClose.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.querySelectorAll('[data-gift-modal-close]').forEach(function (el) {
        el.addEventListener('click', this.onClose);
      }, this);
      this.addEventListener('keyup', this.onKeyUp);
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      if (this.parentElement !== document.body) document.body.appendChild(this);
    }

    onClose(event) {
      event.preventDefault();
      this.hide();
    }

    onKeyUp(event) {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') this.hide();
    }

    show(unlocked) {
      var items = this.querySelectorAll('[data-gift-item]');
      items.forEach(function (el) {
        el.hidden = unlocked.indexOf(el.getAttribute('data-gift-item')) === -1;
      });

      if (this.subtitleEl) {
        var text = unlocked.map(function (key) { return LABELS[key]; }).filter(Boolean).join(' ');
        this.subtitleEl.textContent = text || 'A free gift has been added to your cart.';
      }

      this.openedBy = document.activeElement;
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');

      if (typeof trapFocus === 'function' && this.dialog) {
        trapFocus(this, this.dialog);
      } else if (this.dialog) {
        this.dialog.focus();
      }
    }

    hide() {
      if (!this.hasAttribute('open')) return;
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.openedBy);
    }
  }

  customElements.define('np-gift-modal', NpGiftModal);
})();
